module.exports = __webpack_public_path__ + "static/img/shanshi.a6badef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/shanshi.png
// module id = Ep/F
// module chunks = 1